module.exports = __webpack_public_path__ + "img/payment_mb_11.815d204d.png";